if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyATC extends HTMLElement {
      constructor() {
        super();
        this.stopScroll = document.querySelector('footer');
        if (window.innerWidth > 989) return;
        this.handleSticky();
      }

      handleSticky() {
        document.addEventListener('scroll', () => this.onAlwaysSticky());
      }

      onAlwaysSticky() {
        const stopScrollPosition = this.stopScroll.getBoundingClientRect().top;
        const stickyBottom = this.getBoundingClientRect().bottom;
        stopScrollPosition > stickyBottom ? this.classList.remove('hide') : this.classList.add('hide');
      }
    },
  );
}
